import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { Box } from '../Box/Box.js';
import styled from 'styled-components';

var scrollSnapNoneClass = 'scroll-snap-none';
var CarouselChildStyled = /*#__PURE__*/styled(Box).withConfig({
  displayName: "CarouselChildstyled__CarouselChildStyled",
  componentId: "sc-vh5nl5-0"
})(_defineProperty({}, "&.".concat(scrollSnapNoneClass), {
  scrollSnapAlign: 'none'
}));

export { CarouselChildStyled, scrollSnapNoneClass };
//# sourceMappingURL=CarouselChild.styled.js.map
